export default __webpack_public_path__ + "ubisoft-playtest-icon-warning-black.webp";